module.exports = __webpack_public_path__ + "img/remun.c20a2d19.jpg";